import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { GlassCard } from './ui/GlassCard';
import { Button } from './ui/Button';
const plans = [{
  name: 'Esencja',
  price: '179',
  description: 'Dla małych zespołów i startupów',
  features: ['Do 1,000 subskrybentów', 'Podstawowa analityka', 'Wsparcie email', '1 członek zespołu'],
  highlight: false
}, {
  name: 'Momentum',
  price: '449',
  description: 'Dla szybko rosnących firm',
  features: ['Do 10,000 subskrybentów', 'Zaawansowane raporty', 'Wsparcie priorytetowe', '5 członków zespołu', 'API Access'],
  highlight: true
}, {
  name: 'Apogeum',
  price: '999',
  description: 'Dla dużych organizacji',
  features: ['Nielimitowani subskrybenci', 'Dedykowany opiekun', 'SLA 99.9%', 'Nielimitowani członkowie', 'Custom Integrations', 'White-label'],
  highlight: false
}];
export function PricingSection() {
  return <section className="relative z-10 py-24 px-4" data-id="element-97">
      <div className="max-w-7xl mx-auto" data-id="element-98">
        <div className="text-center mb-16" data-id="element-99">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-100">
            Proste, przejrzyste ceny
          </motion.h2>
          <p className="text-slate-400" data-id="element-101">
            Wybierz plan dopasowany do Twojego etapu rozwoju.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-102">
          {plans.map((plan, index) => <GlassCard key={plan.name} className={`p-8 relative ${plan.highlight ? 'border-emerald-500/50 bg-emerald-900/10' : ''}`} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} hoverEffect={true} data-id="element-103">
              {plan.highlight && <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-emerald-500 text-white text-xs font-bold uppercase tracking-wider rounded-full shadow-lg shadow-emerald-500/40" data-id="element-104">
                  Najpopularniejszy
                </div>}

              <div className="mb-8" data-id="element-105">
                <h3 className="text-lg font-medium text-emerald-400 mb-2" data-id="element-106">
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-2" data-id="element-107">
                  <span className="text-4xl font-bold text-white" data-id="element-108">
                    {plan.price} zł
                  </span>
                  <span className="text-slate-400" data-id="element-109">/mies</span>
                </div>
                <p className="text-sm text-slate-400" data-id="element-110">{plan.description}</p>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-111">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-slate-300" data-id="element-112">
                    <div className="mt-0.5 w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center shrink-0" data-id="element-113">
                      <Check className="w-3 h-3 text-emerald-400" data-id="element-114" />
                    </div>
                    {feature}
                  </li>)}
              </ul>

              <Button variant={plan.highlight ? 'primary' : 'outline'} className="w-full" data-id="element-115">
                Wybierz pakiet
              </Button>
            </GlassCard>)}
        </div>
      </div>
    </section>;
}